// Visit https://api.openweathermap.org & then signup to get our API keys for free
module.exports = {
  key: "232b78b3b954d9f7df40da40b741159a",
  base: "https://api.openweathermap.org/data/2.5/",
};
